module.exports = __webpack_public_path__ + "static/media/双十一-3_01.ec3b392a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/双十一-3_01.jpg
// module id = 981
// module chunks = 0